import { store as auth } from '@/modules/auth'
import { store as event } from '@/pages/event'
import { store as users } from '@/pages/users'
import { store as roles } from '@/pages/roles'
import { store as language } from '@/pages/languages'
import { store as translation } from '@/pages/translations'
import { store as sympla } from '@/pages/event/sympla'
import { store as rdstation } from '@/pages/event/rdstation'
import { store as emailTemplate } from '@/pages/event/email'
import { store as speaker } from '@/pages/speakers'
import { store as schedule } from '@/pages/schedules'
import { store as room } from '@/pages/rooms'
import { store as partner } from '@/pages/partners'
import { store as partnerVideos } from '@/pages/partners/videos'
import { store as partnerArchives } from '@/pages/partners/archives'
import { store as partnerProducts } from '@/pages/partners/products'
import { store as partnerContacts } from '@/pages/partners/contacts'
import { store as asking } from '@/pages/rooms/askings'
import { store as publicQuestion } from '@/pages/rooms/public-questions'
import { store as quiz } from '@/pages/rooms/quiz'
import { store as poll } from '@/pages/rooms/poll'
import { store as streaming } from '@/pages/rooms/transmission'
import { store as callAction } from '@/pages/rooms/call-action'
import { store as roomBanner } from '@/pages/rooms/banners'
import { store as wordCloud } from '@/pages/rooms/word-cloud'
import { store as participant } from '@/pages/participants'
import { store as survey } from '@/pages/survey'
import { store as gamification } from '@/pages/gamification'
import { store as archive } from '@/pages/archives'
import { store as video } from '@/pages/videos'
import { store as videoCategory } from '@/pages/video-categories'
import { store as partnerCategory } from '@/pages/partner-categories'
import { store as videoComment } from '@/pages/video-comments'
import { store as timelineBanner } from '@/pages/event/timelineBanners'
import { store as lobbyBanner } from '@/pages/event/lobbyBanners'
import { store as indicationReward } from '@/pages/event/indication'
import { store as raffle } from '@/pages/raffle'
import { store as ecampaign } from '@/pages/email/campaign'
import { store as campaign } from '@/pages/wa/campaign'
import { store as template } from '@/pages/event/wa/templates'
import { store as wa } from '@/pages/event/wa'
import { store as formBuilder } from '@/pages/form-builder'
import { store as customList } from '@/pages/custom-lists'
import dashboards from '@/modules/dashboards/store'

export default {
  auth,
  event,
  users,
  roles,
  language,
  translation,
  sympla,
  rdstation,
  emailTemplate,
  speaker,
  schedule,
  room,
  asking,
  publicQuestion,
  quiz,
  poll,
  streaming,
  callAction,
  roomBanner,
  wordCloud,
  participant,
  survey,
  gamification,
  archive,
  video,
  videoCategory,
  videoComment,
  raffle,
  partner,
  partnerCategory,
  partnerVideos,
  partnerArchives,
  partnerProducts,
  partnerContacts,
  timelineBanner,
  lobbyBanner,
  indicationReward,
  ecampaign,
  campaign,
  template,
  wa,
  formBuilder,
  customList,
  dashboards
}
